import { GetSpecialistDetailResponse } from '@/modules/accredited-establishments/api'

/*
 * A modalidade de atendimento nao vem pronta da API do detalhe: e derivada de
 * `remote` mais a presenca de endereco.
 */
const getAppointmentLabel = ({
  remote,
  address
}: Pick<GetSpecialistDetailResponse, 'remote' | 'address'>) => {
  const presential = Boolean(address?.length)

  if (presential && remote) return 'Presencial e Online'
  if (presential) return 'Presencial'
  if (remote) return 'Online'

  return undefined
}

export { getAppointmentLabel }
